import React from 'react';
import './RiskMeter.css';

const RiskMeter = ({ riskScore = 0, riskLevel = 'low' }) => {
  // Calculate position (0-100%)
  const position = Math.max(0, Math.min(100, riskScore));
  
  // Determine risk level colors
  const getRiskColor = () => {
    if (riskScore <= 20) return '#28a745'; // Green - Minimal
    if (riskScore <= 40) return '#ffc107'; // Yellow - Low
    if (riskScore <= 60) return '#fd7e14'; // Orange - Medium
    if (riskScore <= 80) return '#dc3545'; // Red - High
    return '#721c24'; // Dark Red - Critical
  };

  const getRiskLabel = () => {
    if (riskScore <= 20) return 'Minimal';
    if (riskScore <= 40) return 'Low';
    if (riskScore <= 60) return 'Medium Security Risk';
    if (riskScore <= 80) return 'High';
    return 'Critical';
  };

  return (
    <div className="risk-meter-container">
      <div className="risk-meter-bar">
        <div 
          className="risk-meter-gradient"
          style={{ 
            background: `linear-gradient(to right, #28a745 0%, #ffc107 25%, #fd7e14 50%, #dc3545 75%, #721c24 100%)`
          }}
        />
        <div 
          className="risk-meter-pointer"
          style={{ left: `${position}%` }}
        />
      </div>
      <div className="risk-meter-labels">
        <span>Minimal</span>
        <span>Low</span>
        <span>Medium Security Risk</span>
        <span>High</span>
        <span>Critical</span>
      </div>
      <div className="risk-meter-indicator" style={{ color: getRiskColor() }}>
        Current Risk: {getRiskLabel()}
      </div>
    </div>
  );
};

export default RiskMeter;

